require('./accessKeyChangeSuccessStep.scss');
//@vendor
const React = require('react');
//@commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');


const AccessKeyChangeSuccessStep = () => {
    const exitLink = `/myProfile`;
    const goBackButtonLabel = formatText('profileKeys-successLink').toUpperCase();
    const title = formatText('profileKeys-successTitle');
    const goBackButton = {
        label: goBackButtonLabel,
        url: exitLink
    }
    return (
        <WizardSuccess
            successMessage={title}
            mainButton={goBackButton}
        >
            <p className="profile-keys-signature-success__caption">
                <FormattedText value="profileKeys-successSubTitle" />
            </p>
        </WizardSuccess>
    );
};

module.exports = AccessKeyChangeSuccessStep;
